import React from "react";

import { formatCurrencyRange, formatPayoutOrDash } from "utils";

import { CurrencyCode } from "consts";

import { Flex, Typography } from "components";

export type PayoutAmountProps = {
  amount: number;
  maxAmount?: number;
  hasAllotment: boolean;
  currency?: CurrencyCode;
  variant?: "h1" | "h2";
  co2Value?: string;
  dataTestId?: string;
  className?: string;
};

export const PayoutAmount = ({ amount, maxAmount, hasAllotment, currency, variant = "h2", co2Value, dataTestId, className }: PayoutAmountProps) => {
  const valueText =
    hasAllotment && maxAmount !== undefined
      ? formatCurrencyRange(amount, maxAmount, { decimals: 0, currency })
      : formatPayoutOrDash(amount, hasAllotment, currency);

  // No CO2e line: render a bare Typography so callers with their own layout/measurement logic
  // (e.g. resize-driven badge truncation) see the exact same DOM shape as before extraction.
  if (!co2Value) {
    return (
      <Typography variant={variant} className={className} data-testid={dataTestId} noWrap>
        {valueText}
      </Typography>
    );
  }

  return (
    <Flex vertical gap={4} className={className}>
      <Typography variant={variant} data-testid={dataTestId} noWrap>
        {valueText}
      </Typography>
      <Typography variant="paragraph-s" color="grey-600" data-testid={dataTestId ? `${dataTestId}-co2` : undefined}>
        {co2Value}
      </Typography>
    </Flex>
  );
};

export default PayoutAmount;
